import { Validator } from "breeze-client";
import * as $ from 'jquery';

function removeValidator(validators, name) {
    var index = -1;

    $.each(validators, function (i, val) {
        if (val.name === name) {
            index = Number(i);
            return;
        }
    });

    if (index > -1)
        validators.splice(index, 1);
}

function validator(context, messageTemplate, name, fn) {
    var defaultContext = { messageTemplate: messageTemplate };

    $.extend(defaultContext, context);

    return new Validator(
        name,
        fn,
        defaultContext
    );
}

function int16Validator(v, ctxt) {
    return intValidator(v, ctxt, -32768, 32767);
}

function int32Validator(v, ctxt) {
    return intValidator(v, ctxt, -2147483648, 2147483647);
}

function int64Validator(v, ctxt) {
    return intValidator(v, ctxt, -9223372036854775808, 9223372036854775807);
}

function intValidator(v, ctxt, minValue, maxValue) {
    if (v == null || v === "") return true; //if empty string then required will validate empty string
    if (typeof v === "string") {
        v = parseInt(v, 0);
    }
    if ((typeof v === "number") && (!isNaN(v)) && Math.floor(v) === v) {
        if (minValue != null && v < minValue) {
            return false;
        }
        if (maxValue != null && v > maxValue) {
            return false;
        }
        return true;
    } else {
        return false;
    }
}

function numValidator(v, ctxt) {
    if (v == null || v === "") return true; //if empty string then required will validate empty string
    if (typeof v === "string") {
        v = parseFloat(v);
    }
    if ((typeof v === "number") && !isNaN(v)) {
        return true;
    } else {
        return false;
    }
}

function requiredValidator(context) {
    return validator(context,
        '%displayName% is required',
        "required",
        function (value, ctxt) {
            if ((value !== 0 && !value) || value == null) return false; // '== null' matches null and empty string

            return true;
        }
    );
}

function rangeValidator(context) {
    return validator(context,
        '%displayName% must be between ' + context.min + ' and ' + context.max,
        "range_" + context.min + '_and_' + context.max,
        function (value, ctxt) {
            if (!value || value == null) return true;

            if (value < context.min || value > context.max) return false;

            return true;
        }
    );
}

function regexValidator(context) {
    return validator(context,
        '%displayName% is not in the correct format',
        'regex_' + context.name,
        function (value, ctxt) {
            if (!value || value == null) return true;

            var patt = context.regex;// new RegExp(context.regex, 'igm');
            return patt.test(value);
        }
    );
}

function currencyValidator(context) {
    return validator(context,
        '%displayName% must be entered as currency',
        'currency',
        function (value, ctxt) {
            if (!value || value == null) return true;

            //Allows for US and International currency formats
            return /(?:^\d{1,3}(?:\.?\d{3})*(?:,\d{2})?$)|(?:^\d{1,3}(?:,?\d{3})*(?:\.\d{2})?$)/.test(value);
        }
    );
}

function emailValidator(context) {
    return validator(context,
        '%displayName% must be a valid e-mail address',
        'email',
        function (value, ctxt) {
            if (!value || value == null) return true;

            return /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i.test(value);
        }
    );
}

function urlValidator(context) {
    return validator(context,
        '%displayName% must be a valid URL',
        'url',
        function (value, ctxt) {
            if (!value || value == null) return true;

            return /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi.test(value);
        }
    );
}

function creditCardValidator(context) {
    return validator(context,
        '%displayName% is not a valid credit card number',
        'creditCard',
        function (value, ctxt) {
            if (!value || value == null) return true;

            var cc = value.replace(/[^\d]/g, '');

            if (luhn(cc))
                return /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/.test(cc);

            return false;
        }
    );
}

function luhn(cc) {
    var sum = 0;
    var i;

    for (i = cc.length - 2; i >= 0; i -= 2) {
        sum += Array(0, 2, 4, 6, 8, 1, 3, 5, 7, 9)[parseInt(cc.charAt(i), 10)];
    }
    for (i = cc.length - 1; i >= 0; i -= 2) {
        sum += parseInt(cc.charAt(i), 10);
    }
    return (sum % 10) == 0;
}

export function setupValidators(validators, meta) {

    for (var index in validators) {
        switch (validators[index].name) {
            case "int16":
                validators[index].valFn = int16Validator;
                break;
            case "int32":
                validators[index].valFn = int32Validator;
                break;
            case "int64":
                validators[index].valFn = int64Validator;
                break;
            case "number":
                validators[index].valFn = numValidator;
        }
    }

    if (meta.requiredErrorMessage) {
        removeValidator(validators, "required");
        validators.push(requiredValidator({ messageTemplate: meta.requiredErrorMessage }));
    }

    if (meta.range) {
        removeValidator(validators, "range");
        validators.push(rangeValidator({ min: meta.range.min, max: meta.range.max, messageTemplate: meta.range.errorMessage }));
    }

    if (meta.regEx)
        validators.push(regexValidator({ regex: meta.regEx.expression, name: meta.displayName, messageTemplate: meta.regEx.errorMessage }));

    if (meta.myType === "EmailAddress")
        validators.push(emailValidator({ messageTemplate: meta.myType.errorMessage }));

    if (meta.myType === "Currency")
        validators.push(currencyValidator({ messageTemplate: meta.myType.errorMessage }));

    if (meta.myType === "Url" || meta.myType === "ImageUrl")
        validators.push(urlValidator({ messageTemplate: meta.myType.errorMessage }));

    if (meta.myType === "Currency")
        validators.push(creditCardValidator({ messageTemplate: meta.myType.errorMessage }));
}
